import { Message } from "@/types";

import { axios } from "../axios.instance";

export type GetChatMessagesRequest = {
  chatId: string;
  perPage?: number;
  cursor?: string;
};

export type GetChatMessagesResponse = {
  data: Message[];
  meta: {
    hasNextPage: boolean;
    nextCursor?: string;
  };
};

export const getChatMessages = async (body: GetChatMessagesRequest): Promise<GetChatMessagesResponse> => {
  const { data } = await axios.get(`/chats/${body.chatId}/messages`, {
    params: {
      perPage: body.perPage,
      cursor: body.cursor,
    },
  });

  return data;
};
